import { ExMenuItem, ExSelect, SelectType } from '@boomi/exosphere';

interface FilterSelectProps<T extends string> {
    placeholder: string;
    options: readonly T[];
    value: Set<T>;
    onChange: (next: Set<T>) => void;
}

const FilterSelect = <T extends string>({
    placeholder,
    options,
    value,
    onChange,
}: FilterSelectProps<T>) => (
    <ExSelect
        type={SelectType.MULTI}
        placeholder={placeholder}
        onChange={(e) => onChange(new Set(value).add(e.detail.value as T))}
        onRemove={(e) => {
            const next = new Set(value);
            next.delete(e.detail.valueRemoved as T);
            onChange(next);
        }}
        onClear={() => onChange(new Set())}
    >
        {options.map((option) => (
            <ExMenuItem key={option} value={option}>
                {option}
            </ExMenuItem>
        ))}
    </ExSelect>
);

export default FilterSelect;
